import { UtilsService } from 'app/components/utils/utils.service';
import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '../common/session/session.service';

@Pipe({
  name: 'customTranslation'
})
export class CustomTranslationPipe implements PipeTransform {

  constructor(
    private sessionService: SessionService, private utilsService:UtilsService
  ) {}

  transform(key: string, defaultValue: string = 'default', language: string  = 'es'): string  {
    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    let sapCode = eventData['sapCode'];
    let text = defaultValue; // Set default value initially
    const customFile = this.sessionService.get('customTranslations_' + sapCode + '_' + language);
    if(customFile) {
      const translations = JSON.parse(customFile);
      text = translations[key];
    }
    if(this.utilsService.isEmpty(text))
      text = defaultValue;
    return text;
  }

}
